import { Link } from "react-router-dom";

export const Logo = ({ to = "/", light = false }) => (
  <Link to={to} className="flex items-center gap-2.5 group" data-testid="brand-logo">
    <span className={`grid h-8 w-8 place-items-center rounded-sm font-display text-lg font-extrabold transition-transform duration-300 group-hover:rotate-6 ${light ? "bg-white text-slate-900" : "bg-slate-900 text-white"}`}>
      V
    </span>
    <span className={`font-display text-xl font-extrabold tracking-tight ${light ? "text-white" : "text-stone-900"}`}>
      VirtuForce<span className="text-amber-600">.</span>
    </span>
  </Link>
);
